import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { mapPreofferItemResponseToPreofferItem } from './preoffers.mappers';

export const getPreoffersState = (state: RootState) => state.preoffers;

export const getPreoffersItemsState = createSelector(getPreoffersState, (state) => {
  const items = state.preoffers.ids.reduce((accum, curr) => {
    accum[curr] = {
      ...mapPreofferItemResponseToPreofferItem(state.preoffers.items[curr]),
    };
    return accum;
  }, {});
  return { ...state.preoffers, items };
});
